import type { ReactNode } from "react";
import { createAuthorizationScopeKey, useProductConfig } from "@ilabel/platform-core";
import { TeamMembersRuntime } from "@ilabel/team-members/runtime";
import { useAppSession } from "./app-session-context.js";
import { api } from "../lib/api-client.js";

/** Product session adaptation; browsing persistence is owned by the shared page. */
export function TeamMembersPageContext({ children }: { readonly children: ReactNode }) {
  const { session, sessionPending, sessionError } = useAppSession();
  const product = useProductConfig();
  const accountId = String(session?.account?.id ?? "");
  if (!session || sessionPending || sessionError || !accountId) return null;
  const authorizationScope = createAuthorizationScopeKey(session);
  return <TeamMembersRuntime key={`${product.code}:${authorizationScope}`} request={api}
    browserContext={{ product: product.code, accountId, authorizationScope }}>
    {children}
  </TeamMembersRuntime>;
}
